var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcoMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96522 0.861328H15.0527C16.098 0.861328 16.9761 1.7394 16.9761 2.82654V12.3599C16.9761 13.4471 16.098 14.3251 15.0527 14.3251H8.65531L4.64125 16.7921C4.26494 17.0012 3.80499 16.7085 3.8468 16.2904V14.3251H1.96522C0.878075 14.3251 0 13.4471 0 12.3599V2.82654C0 1.7394 0.878075 0.861328 1.96522 0.861328ZM15.0527 1.90666H1.96522C1.46346 1.90666 1.04533 2.32479 1.04533 2.82654V12.3599C1.04533 12.8617 1.46346 13.238 1.96522 13.238H4.34856C4.64125 13.238 4.89213 13.4889 4.89213 13.7816V15.3705L8.19537 13.3634C8.27899 13.2798 8.40443 13.238 8.48806 13.238H15.0527C15.5545 13.238 15.9308 12.8617 15.9308 12.3599V2.82654C15.9308 2.32479 15.5545 1.90666 15.0527 1.90666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2477 8.05325L6.7737 10.6038C6.43919 10.8129 5.97925 10.562 5.97925 10.1439V5.00089C5.97925 4.58276 6.48101 4.33188 6.81551 4.58276L11.2477 7.13336C11.5822 7.34243 11.5822 7.84418 11.2477 8.05325ZM7.06639 9.22401L9.90968 7.5933L7.06639 5.92078V9.22401Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcoMedia);
export default __webpack_public_path__ + "static/media/menu-ico_media.8b0dac35a0b308020e3183bb9f3a3bb8.svg";
export { ForwardRef as ReactComponent };